import { environment } from '../../environments/environment';

export const isAvailableFeature = (feature: string): boolean => {
  if (environment.env_name !== 'production' && environment.env_name !== 'preprod') {
    return true;
  }

  const featureToggling = environment.featureToggling;
  if (!(feature in environment.featureToggling)) {
    console.warn(`Unable to find feature with name ${feature}`);
    return false;
  }
  type ObjectKey = keyof typeof featureToggling;
  const featureKey = feature as ObjectKey;
  return featureToggling[featureKey];
};
